import { isPlainObject, isArray } from './is'
/**
 * 设置对象的属性值，可以多层级设置
 * @param obj 对象
 * @param path 路径
 * @param value 值
 * @returns 返回obj
 * @example  set({}, 'a.b.c', 1111)
 */
export const set = (obj: Record<string, any>, path: string, value: any): Record<string, any> => {
  let pathArr: string[] = []
  if (Array.isArray(path) !== true) {
    pathArr = path.toString().match(/[^.[\]]+/g) || []
  }
  pathArr
    .slice(0, -1)
    .reduce(
      (a, c, i) =>
        Object(a[c]) === a[c]
          ? a[c]
          : (a[c] =
              Math.abs(pathArr[i + 1] as unknown as number) >> 0 === +pathArr[i + 1] ? [] : {}),
      obj,
    )[pathArr[pathArr.length - 1]] = value
  return obj
}

/**
 * 扁平化对象key
 * @param input object
 * @param flattenKey string
 * @param output object
 * @returns object
 */
export function flattenObject(input: object, flattenKey = '', output: object = {}) {
  const objKeys = Object.keys(input)
  objKeys.forEach((key) => {
    const value = input[key]
    const nextKey = flattenKey + key
    if (isPlainObject(value)) {
      flattenObject(value, nextKey + '.', output)
    } else {
      output[nextKey] = value
    }
  })
  return output
}

/**
 * 扁平的对象转为嵌套的对象
 * @param input 对象
 * @returns 对象
 */
export function flattened2Nest(input: object) {
  const objKeys = Object.keys(input)
  const result: object = {}
  objKeys.forEach((key) => {
    const splitedKeys = key.match(/[^.]+/g) || []
    const lastKey = splitedKeys.pop() as string
    splitedKeys.reduce((acc, cur) => (acc[cur] = {}), result)[lastKey] = input[key]
  })
  return result
}

export function omit<T extends object>(obj: T, paths: string | string[]) {
  const pathsArr = isArray(paths) ? paths : [paths]
  const retObj = { ...obj }
  pathsArr.forEach((path) => {
    Reflect.deleteProperty(retObj, path)
  })
  return retObj
}

export function get(obj: object, paths: string | string[]) {
  if (!isPlainObject(obj)) {
    return
  }
  const pathsArr = isArray(paths) ? paths : paths.match(/[^.]+/g)
  return (pathsArr || []).reduce((o, cur) => (o || {})[cur], obj) as any
}
